import { PropsWithChildren } from 'react'

export default function EmptyLayout({ children }: PropsWithChildren) {
  return <div>{children}</div>
}
